module.exports = __webpack_public_path__ + "static/img/f-biotic.0311eedb.jpg";